new Splide( '.splide.whoblock-custom-slider', {
	type        : 'loop',
	autoplay    : true,
	interval    : 5000,
	pauseOnHover: true,
	pauseOnFocus: true,
	rewind      : true,
	arrows      : true,
	pagination  : false,
} ).mount()